enum ANCHORS {
  FEATURED_SCENARIOS = 'featured_scenarios',
  GENERATOR_SCENARIO = 'create-scenario',
}

export { ANCHORS };
